import { render, staticRenderFns } from "./addQuota.vue?vue&type=template&id=13796e94&scoped=true&"
import script from "./addQuota.vue?vue&type=script&lang=js&"
export * from "./addQuota.vue?vue&type=script&lang=js&"
import style0 from "./addQuota.vue?vue&type=style&index=0&id=13796e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13796e94",
  null
  
)

export default component.exports